import * as React from 'react';
import {Alert} from '@mui/material';
import {useTranslation} from 'react-i18next';

export function NoLongStayRuleAlert() {
	const {t} = useTranslation(['tenantAdmin']);

	return <Alert sx={{mt: 2, mb: 2}} severity="info">{t('tenantAdmin:pms.longStay.noRuleSet')}</Alert>;
}
